export default __webpack_public_path__ + "static/media/z_wdt_c_2_3.a4f9cbe7.mp3";